import EligibilityLayout from '@src/ui/layouts/EligibilityLayout';
import TransitionView from '@src/ui/views/debtCon/TransitionView';

const Transition = () => {
    return (
        <EligibilityLayout>
            <TransitionView />
        </EligibilityLayout>
    );
};

export default Transition;
